import React from 'react'
import styles from './FormBoxStaticText.less'
import { FormBoxContext } from './FormBoxContext'
import _ from 'common-tools/LodashHelper'

export class FormBoxStaticText extends React.Component {
  static contextType = FormBoxContext

  render () {
    const { text, hide, name, debugMode: localDebugMode = false } = this.props
    const { sideEffects = {}, debugMode: contextDebugMode = false } = this.context

    if (hide === true) {
      return null
    }

    if (name) {
      const effects = _.get(sideEffects, name) || {}

      if (effects.hide) {
        return null
      }
    }

    let debugMode = contextDebugMode === true

    if (localDebugMode === true) {
      debugMode = true
    }

    if (debugMode) {
      return <div className={styles.formBoxStaticTextDebug}>
        <div className={styles.formBoxStaticTextDebugText}>StaticText: {name || 'Not Named'}</div>
        {text}
      </div>
    } else {
      return <div className={styles.formBoxStaticText}>
        {text}
      </div>
    }
  }
}
